
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getCellOverlayStyle } from '../styles/tiles-grid-cell-overlay-style';

const CellOverlay = ({ children, classes }) => (
  <div className={classnames('cell-overlay', classes.cellOverlayContainer)}>
    {children}
  </div>
);

CellOverlay.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    cellOverlayContainer: PropTypes.string,
  }).isRequired,
};

CellOverlay.defaultProps = {
  children: null,
};

export const TilesGridCellOverlay = withDefaultStyles(CellOverlay, getCellOverlayStyle);
